<template>
    <div>
        <my-form
            class="form-page"
            v-model="form"
            table
            :readonly="!cyry"
            send-str
            label-width="180px"
            @submit="submit"
            @cancle="cancleHandler">
                <el-form-item 
                    label="当前参与人员" >
                        {{peoplenamejoined}}
                </el-form-item>

                <el-form-item 
                    label="参与人员" 
                    prop="peoplecode" 
                    :rules="newRule('参与人员', 'required')
                    ">
                        <my-select
                            multiple
                            style="width:100%"
                            v-model="form.peoplecode"
                            :data="joinList"
                            :props="{value:'id',label:'truename'}"
                            2way="truename"
                            :truename.sync="form.peoplename" :disabled="!cyry"
                            @visiblechange="visiblechange">
                        </my-select>
                </el-form-item>

                <template slot="btn" slot-scope="scope">
                    <el-button @click="saveHandler(scope.submitHandler)" type="primary" icon="el-icon-circle-check">
                        提交
                    </el-button>
                    <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
                </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from "@views/mixins/form-page";
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [FORM_PAGE_MIXIN,LIST_PAGE_MIXIN],
    components: {
     
    },
    props: {
        data: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form:{
                peoplename:[],
                peoplecode:[]
            },
            joinList:[],
            peoplenamejoined:'',
            cyry:true

        }
    },
    created() {
        var that = this
        //是否关联招标方案
        
        this.$get(`${this.getGetters('ageUrl')}/Zbdl/collaboration/isglzbrelation.json`,{
            procode:this.data
        },(data,res)=>{     
            if(data.relationcode!==null) {
                if(data.currentcode==data.jbzrcode) {
                    this.cyry=true
                }
                else {
                    this.cyry=false
                }
            }
            else {
                if(data.adduserid==data.currentcode) {
                    this.cyry=true
                }
                else {
                    this.cyry=false
                }
            }
        })  
        //查看已参与人员
        that.$get(`${that.getGetters('ageUrl')}/Zbdl/collaboration/ycypeople.json`,{procode:this.data},(data,res)=>{
            this.peoplenamejoined=data.peoplename
            // this.form.peoplename=data.peoplename.split(',')
            // this.form.peoplecode=data.peoplecode.split(',')
            // let dataIntArr=[]
            // //字符串数组转换成整型数组
            // this.form.peoplecode.forEach(item => {  
            //     dataIntArr.push(+item);  
            // });  
            // this.form.peoplecode=dataIntArr
        })
    },
    methods: {
        visiblechange() {
            //查看可参与人员
            this.$get(`${this.getGetters('ageUrl')}/Zbdl/collaboration/getktpeople.json`,{
                procode:this.data
            },(data,res)=>{     
                this.joinList=data
            })  
        },
        // 保存
        saveHandler(cb) {
            this.form.peoplename=this.form.peoplename.join(',')
            this.form.peoplecode=this.form.peoplecode.join(',')
            this.form.procode=this.data
            cb && cb();
        },
        submit(){           
            var that = this 
            this.$post(`${this.getGetters('ageUrl')}/Zbdl/collaboration/addpeople.json`,this.form,(data,res)=>{
                ShowMsg(res.msg);
                this.$emit('cancle')
            })
        }
    },
    mounted() {
        var that = this;
        
    }
}
</script>

<style>
    .el-input.is-disabled .el-input__inner{ color: #333; }
     /* .el-select-dropdown { z-index: 2200!important; } */
</style>